module.exports = __webpack_public_path__ + "img/logo-cancer.95b4739e.svg";